<template>
  <div>
    <v-card>
      <v-card-title>
        <b-row>
          <b-col cols="10">
            <!-- <v-btn @click="salvarContato" color="primary" x-large>
                <v-icon>mdi-content-save</v-icon>Salvar
              </v-btn> -->

            tecnico Inicial
          </b-col>
          <b-col cols="2" :style="{ padding: '10px' }" class="text-right">
            <v-btn @click="modal_novo = false" text icon x-large>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </b-col>
        </b-row>
      </v-card-title>

      <v-card-text>
        <b-container fluid>
          <TabView :activeIndex.sync="activeTabAtendimento">
            <TabPanel header="Atendimento Inicial">
              <b-container fluid>
                <b-row>
                  <b-col cols="6">
                    <AutoBusca
                      id="cliente"
                      item_id="id"
                      item_text="nome"
                      item_campos="cli.id as id, cli.id|| ' - ' || TRIM(cli.nome) || ' - ' || cli.cnpj || ' ('||TRIM(cid.nome)||'/'||cid.uf||')' as nome, cli.cnpj"
                      item_busca="cli.id|| '-' || TRIM(UPPER(cli.nome))|| '-' || TRIM(UPPER(cli.cnpj)) "
                      item_left="LEFT JOIN cidade cid ON cid.codcid=cli.codcid"
                      tabela="cliente cli"
                      :value="id_cli"
                      @getID="getID"
                      :label="'Digite o cliente'"
                      condicao="cli.id > 10000"
                    />

                    <small>{{ dtStatus }}</small>
                  </b-col>
                  <b-col cols="3">
                    <v-text-field
                      label="AnyDesk"
                      placeholder=""
                      outlined
                      hide-details="auto"
                      v-model="info_any"
                    ></v-text-field>
                  </b-col>
                  <b-col cols="3">
                    <v-text-field
                      label="AnyDesk Password"
                      placeholder=""
                      outlined
                      hide-details="auto"
                      v-model="info_any_senha"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3">
                    <v-select
                      v-model="tipo"
                      :items="Enum.situacao"
                      outlined
                      label="Tipo do chamado"
                      hide-details="auto"
                      item-text="text"
                      item-value="val"
                      no-data-text="Nenhuma Informação disponível"
                    ></v-select>
                  </b-col>
                  <b-col cols="3">
                    <v-combobox
                      v-model="tags"
                      :items="items"
                      label="Tags"
                      multiple
                      outlined
                      :hide-details="true"
                      :hide-no-data="true"
                      :return-object="false"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          v-bind="data.attrs"
                          :input-value="data.selected"
                          :disabled="data.disabled"
                          @click:close="data.parent.selectItem(data.item)"
                        >
                          <v-avatar
                            class="accent white--text"
                            left
                            v-text="data.item.slice(0, 1).toUpperCase()"
                          ></v-avatar>
                          {{ data.item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3">
                    <AutoBuscaDrop
                      id="tecnico"
                      item_id="id"
                      item_text="nome"
                      item_pk="id"
                      item_campos="tec.id as id, tec.nome as nome"
                      item_busca="tec.id::char|| '-' || TRIM(UPPER(tec.nome)) "
                      item_left=""
                      item_ordem="nome"
                      item_condicao="coalesce(ativo,true)=true"
                      tabela="tecnico tec"
                      :value="id_tec_resp"
                      @getID="getID"
                      :label="'Digite o tecnico responsável'"
                    />
                  </b-col>
                  <b-col cols="3">
                    <v-text-field
                      label="Data de previsão"
                      placeholder=""
                      outlined
                      hide-details="auto"
                      v-model="data_pre"
                      type="date"
                    ></v-text-field>
                  </b-col>
                  <b-col cols="3">
                    <v-text-field
                      label="Tempo de duração"
                      placeholder=""
                      outlined
                      hide-details="auto"
                      v-model="tempo"
                      type="time"
                    ></v-text-field>
                  </b-col>
                  <b-col>
                    <v-checkbox
                      v-model="resolvido"
                      label="FINALIZAR"
                      color="grey darken-4"
                    ></v-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <v-text-field
                      label="Assunto"
                      placeholder="Informar assunto"
                      outlined
                      v-model="assunto"
                      hide-details="auto"
                      sync
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="4">
                    <v-text-field
                      label="Contato"
                      placeholder="Não informado"
                      outlined
                      v-model="contato"
                      hide-details="auto"
                    ></v-text-field>
                  </b-col>
                  <b-col cols="4">
                    <v-text-field
                      label="Fone"
                      placeholder="Não informado"
                      outlined
                      v-model="fone"
                      hide-details="auto"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                    ></v-text-field>
                  </b-col>
                  <b-col cols="4">
                    <v-text-field
                      label="Fone 2"
                      placeholder="Não informado"
                      outlined
                      v-model="fone2"
                      hide-details="auto"
                      v-mask="['(##) ####-####', '(##) #####-####']"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <v-text-field
                      label="Email"
                      placeholder="Não informado"
                      outlined
                      v-model="email"
                      hide-details="auto"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <Editor v-model="mensagem" editorStyle="height: 300px">
                    </Editor>
                    <!-- :readonly="disable_recado" -->
                  </b-col>
                </b-row>
              </b-container>
            </TabPanel>
            <TabPanel
              v-if="file.id_cli != null && file.id_cli != ''"
              header="Retornos"
            >
              <b-container fluid>
                <b-row>
                  <b-col>
                    <ChamadoResolucoes
                      :id="id_chamado_resolucoes"
                      :tecnicos="tecnicos"
                      :limpa="limpa_resolucoes"
                      @getResolucoes="getResolucoes"
                      :altura="60"
                    ></ChamadoResolucoes>
                  </b-col>
                </b-row>
              </b-container>
            </TabPanel>
            <TabPanel
              v-if="file.id_cli != null && file.id_cli != ''"
              header="Inf. Conexão"
            >
              <b-container fluid>
                <b-row>
                  <b-col cols="6">
                    <v-text-field
                      label="ID AnyDesk"
                      placeholder="Não informado"
                      outlined
                      v-model="file.info_any"
                      hide-details="auto"
                    ></v-text-field>
                  </b-col>
                  <b-col cols="6">
                    <v-text-field
                      label="Senha AnyDesk"
                      placeholder="Não informado"
                      outlined
                      v-model="file.info_any_senha"
                      hide-details="auto"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <v-text-field
                      label="IP Externo"
                      placeholder="Não informado"
                      outlined
                      v-model="file.info_ip_externo"
                      hide-details="auto"
                    ></v-text-field>
                  </b-col>
                  <b-col cols="6">
                    <v-text-field
                      label="IP Interno"
                      placeholder="Não informado"
                      outlined
                      v-model="file.info_ip_acesso"
                      hide-details="auto"
                    ></v-text-field>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <Editor v-model="file.info" editorStyle="height: 300px">
                    </Editor>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <v-btn @click="salvarInformacoesCli2" text x-large>
                      <v-icon>mdi-content-save</v-icon>Salvar observações
                    </v-btn>
                  </b-col>
                </b-row>
              </b-container>
            </TabPanel>
            <TabPanel
              v-if="file.id_cli != null && file.id_cli != ''"
              header="Terminais/Versões"
            >
              <b-container fluid>
                <div>
                  <b-row>
                    <b-col cols="2">Modulo</b-col>
                    <b-col cols="2">TTY</b-col>
                    <b-col cols="2">Data Acesso</b-col>
                    <b-col cols="2">Versão</b-col>
                  </b-row>
                </div>
                <v-divider></v-divider>
                <div v-for="(i, idx) in dtVersoes" :key="idx">
                  <b-row>
                    <b-col cols="2">{{ i.modulo }}</b-col>
                    <b-col cols="2">{{ i.tty }}</b-col>
                    <b-col cols="2">{{ i.datac }}</b-col>
                    <b-col cols="2">{{ i.puversao }}</b-col>
                  </b-row>
                </div>
              </b-container>
            </TabPanel>
          </TabView>
        </b-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="salvarContato" block color="primary">
          <v-icon>mdi-content-save</v-icon>Salvar atendimento
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import ExecutaSQL from "../domain/ExecutaSQL.js";
import Chamado from "../domain/Chamado.js";
import GenCli from "../domain/Gencli";
import AutoBusca from "../components/AutoBusca.vue";
import AutoBuscaDrop from "../components/AutoBuscaDrop.vue";
//import FotoUser from "../components/FotoUser.vue";
import ChamadoResolucoes from "../components/ChamadoResolucoes.vue";
import _Enum from "../obj/Enum";
import Editor from "primevue/editor";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
//import Tag from "primevue/tag";

export default {
  components: {
    AutoBusca,
    //FotoUser,
    ChamadoResolucoes,
    Editor,
    TabView,
    TabPanel,
    //Tag,
    AutoBuscaDrop,
  },
  props: ["files", "filtro_color", "tecnicos"],
  data: () => ({
    Enum: _Enum,
    file: {},
    file_conexao: {},
    data: [],
    zIndex: 0,
    items_menu: [{ id: 0, title: "Excluir" }],
    sheet_contatos: false,
    filtraChamados: "",
    modal_contatos: false,
    tab_contato: 0,
    modal_novo: false,
    oper: "",
    item_campos_cliente: "",
    id_chamado_resolucoes: "",
    limpa_resolucoes: false,
    disable_recado: false,
    observacao: "",
    modal_view: false,
    modal_conexao: false,
    modal_retorno: false,
    msg_recado: "",
    mensagem_obs: "",
    items: [
      "SageWeb",
      "SageAPP",
      "CobreFacil",
      "Financeiro",
      "SEFAZ",
      "Programação",
      "Manutenção",
      "Sugestão",
      "Dica",
      "Tributário",
      "Contabilidade",
      "Backup",
      "Caixa",
      "Banco de Dados",
      "Nuvem",
    ],
    items_assunto: [
      "Entrar em contato",
      "Erro no Caixa",
      "Importação XML de Nota de compra",
      "SPED Fiscal",
      "Formatou Máquina",
      "Falar com Daniel",
      "Agendar treinamento",
      "Atualização do SAGE",
      "Atualização do Caixa",
      "Não acessa BANCO DE DADOS",
      "SageApp ",
      "Boletos CobreFacil",
      "LEIAME ",
      "Erro no SAGE",
      "Certificado digital",
      "Ganhe Pontos",
    ],
    dtStatus: [],
    dtVersoes: [],
    activeTabAtendimento: 0,

    id_cli: "",
    info_any: "",
    info_any_senha: "",
    tipo: "",
    tags: [],
    id_tec_resp: "",
    data_pre: "",
    tempo: "",
    resolvido: false,
    assunto: "",
    contato: "",
    fone: "",
    fone2: "",
    email: "",
    mensagem: "",
  }),

  watch: {
    modal_novo: function (val) {
      if (!val) this.id_chamado_resolucoes = null;
    },

    files: function (val) {
      this.data = val;
    },
  },

  created() {
    window.addEventListener("keydown", this.onkey);
    if (typeof this.tipoc != "undefined") this.tipo = this.tipoc;
    this.data = this.files;
  },

  mounted() {},

  computed: {
    ...mapGetters("Usuarios", ["getUsuario"]),
    getUser: function () {
      return this.getUsuario();
    },
    files_chamados() {
      let valores = this.data;
      var wbusca = "";
      if (this.filtraChamados != null)
        wbusca = this.filtraChamados.toString().toLowerCase();

      if (wbusca != "") {
        var wvalores = valores.filter((item) => {
          if (item.nome == null) item.nome = "";
          if (item.assunto == null) item.assunto = "";
          return item.assunto.toLowerCase().indexOf(wbusca) > -1 ||
            item.nome.toLowerCase().indexOf(wbusca) > -1 ||
            JSON.stringify(item.tags).toLowerCase().indexOf(wbusca) > -1
            ? item
            : null;
        });
        valores = wvalores;
      } else {
        valores = this.data;
      }

      return valores;
    },
  },

  methods: {
    onkey(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }

      // F2 novo
      if (e.keyCode == 113 && this.multi !== "") {
        //this.novoChamado();
        e.returnValue = false;
        return;
      }

      // F5 refresh
      if (e.keyCode == 116) {
        e.returnValue = false;
        return;
      }

      // F10
      if (e.keyCode == 121) {
        //$(".input-search").focus();
        e.returnValue = false;
        return;
      }
    },

    trataNULL(valor, padrao, prefix) {
      if (valor == null || valor == "") return padrao;
      return prefix + valor;
    },

    testaMenu(chamado, menu) {
      // this.file = chamado;

      if (menu.id == 0) {
        this.excluirChamado(chamado);
      }
    },

    verContato() {
      this.sheet_contatos = true;
    },

    getID(val) {
      if (val.id == "cliente") {
        if (this.file.id_cli != val.value) {
          this.file.id_cli = val.value;
          this.getInformacoesCli(1);
          this.verificaBloqueiosVersoes();
        }
      }

      if (val.id == "tecnico") this.file.id_tec_resp = val.value;
    },

    getInformacoesCli(opt) {
      var wsql =
        " SELECT " +
        "   cli.cnpj, cli.fone, cli.fone2, cli.email, cli.regras, cli.anydesk_id as info_any, " +
        "   cli.anydesk_senha as info_any_senha, cli.ip_acesso as info_ip_externo, " +
        "   cli.ipinterno_acesso as info_ip_acesso, " +
        "   replace(replace(cli.obs_acesso,Chr(10),'<br>'),Chr(13),'<br>') as info " +
        " FROM cliente cli " +
        " WHERE id= " +
        this.file.id_cli;
      var vm = this;
      this.service = new ExecutaSQL(this.$resource);
      this.service.get(wsql).then(
        function (tmp) {
          if (tmp.length > 0) {
            vm.file.cnpj = tmp[0].cnpj;
            if (opt == 1) {
              vm.file.fone = tmp[0].fone;
              vm.file.fone2 = tmp[0].fone2;
              vm.file.email = tmp[0].email;
              vm.file.regras = tmp[0].regras;
              vm.file.info_any_senha = tmp[0].info_any_senha;
              vm.file.info_any = tmp[0].info_any;
              vm.file.info_ip_externo = tmp[0].info_ip_externo;
              vm.file.info_ip_acesso = tmp[0].info_ip_acesso;
              vm.file.info = Vue.atob(tmp[0].info);
              //vm.file.info = Vue.replaceAll(vm.file.info, "\n", "<br>");
            } else if (opt == 2) {
              vm.file_conexao.regras = tmp[0].regras;
              vm.file_conexao.info_any_senha = tmp[0].info_any_senha;
              vm.file_conexao.info_any = tmp[0].info_any;
              vm.file_conexao.info_ip_externo = tmp[0].info_ip_externo;
              vm.file_conexao.info_ip_acesso = tmp[0].info_ip_acesso;
              vm.file_conexao.info = Vue.atob(tmp[0].info);
              /* vm.file_conexao.info = Vue.replaceAll(
                vm.file_conexao.info,
              Chr(10)  "\n",
                "<br>"
              ); */
              vm.modal_conexao = true;
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    editChamado(file) {
      this.oper = "U";
      this.activeTabAtendimento = 0;
      this.file = JSON.parse(JSON.stringify(file));
      this.getInformacoesCli(1);
      this.verificaBloqueiosVersoes();

      this.file.data_pre = Vue.fData2(this.file.data_pre);
      this.file.mensagem = Vue.atob(this.file.mensagem);
      this.file.mensagem = Vue.replaceAll(this.file.mensagem, "\n", "<br>");
      //this.file.mensagem = this.file.mensagem;

      this.file.info = Vue.atob(this.file.info);
      this.file.info = Vue.replaceAll(this.file.info, "\n", "<br>");

      if (file.tags != null && file.tags != "")
        this.file.tags = JSON.parse(file.tags);

      this.id_chamado_resolucoes = this.file.id;

      if (
        this.getUser.id == this.file.id_tec_inicial ||
        this.getUser.id == this.file.id_tec_resp
      )
        this.disable_recado = false;
      else this.disable_recado = true;

      this.modal_novo = true;
    },

    salvarInformacoesCli() {
      var _file = JSON.parse(JSON.stringify(this.file_conexao));
      _file.info = Vue.btoa(_file.info);

      var dados = [
        {
          file: [_file],
        },
      ];

      Vue.Loading("Gravando...", "", this);
      this.service = new Chamado(this.$resource);
      this.service.upCliente(dados).then(
        function () {
          this.modal_conexao = false;
          this.file = {};
          this.file_conexao = {};
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.alertDanger(err, this);
        }
      );
    },

    salvarInformacoesCli2() {
      var _file = {
        id_cli: this.file.id_cli,
        regras: this.file.regras,
        info_any_senha: this.file.info_any_senha,
        info_any: this.file.info_any,
        info_ip_externo: this.file.info_ip_externo,
        info_ip_acesso: this.file.info_ip_acesso,
        info: Vue.atob(this.file.info),
      };

      var dados = [
        {
          file: [_file],
        },
      ];

      Vue.Loading("Gravando...", "", this);
      this.service = new Chamado(this.$resource);
      this.service.upCliente(dados).then(
        function () {
          Vue.CloseLoading(this);
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.alertDanger(err, this);
        }
      );
    },

    contato(file) {
      this.file_conexao = JSON.parse(JSON.stringify(file));
      this.modal_novo = true;
    },

    ViewConexao(file) {
      this.file = file;
      this.file_conexao = JSON.parse(JSON.stringify(file));
      this.getInformacoesCli(2);
    },

    ViewRetorno(file) {
      this.file = file;
      this.id_chamado_resolucoes = this.file.id;
      this.mensagem_obs = Vue.atob(this.file.mensagem);
      this.modal_retorno = true;
      this.resolvido = this.file.resolvido;
    },

    salvarContato() {
      this.salvarChamado();
    },

    novoChamado() {
      this.oper = "I";
      this.file = {
        id: "",
        id_cli: null,
        fone: "",
        fone2: "",
        email: "",
        regras: "",
        tipo: "",
        contato: "",
        mensagem: "",
        nome: "",
        cnpj: "",
        resolvido: false,
        assunto: "",
        data_pre: Vue.fData2(Vue.getData()),
        data_resolvido: "",
        hora_resolvido: "",
        id_tec_inicial: this.getUser.id,
        id_tec_resp: 0,
        info_any: "",
        info_any_senha: "",
        info_ip_externo: "",
        info_ip_acesso: "",
        info: "",
        tags: "",
        tempo: "",
      };

      this.activeTabAtendimento = 0;
      this.file.tipo = "1";
      this.id_chamado_resolucoes = null;
      this.limpa_resolucoes = !this.limpa_resolucoes;
      this.resolucoes = [];
      this.disable_recado = false;
      this.dtStatus = "";
      this.dtVersoes = [];

      this.modal_novo = true;
    },

    atuChamados() {
      this.$emit("confirmouChamado");
    },

    getResolucoes(val) {
      this.resolucoes = val.resolucoes;
    },

    salvarChamado() {
      /* if (this.file.assunto == "") {
        this.file.assunto = "";
      } */

      if (this.file.tipo == "" || this.file.tipo == null) this.file.tipo = "1";
      var _file = JSON.parse(JSON.stringify(this.file));
      _file.mensagem = Vue.btoa(_file.mensagem);
      _file.info = Vue.btoa(_file.info);

      var dados = [
        {
          file: [_file],
          res: this.resolucoes,
        },
      ];

      Vue.Loading("Processando...", "", this);
      this.service = new Chamado(this.$resource);
      this.service.save(dados).then(
        function () {
          this.modal_novo = false;
          this.file = {};
          this.file_conexao = {};
          Vue.CloseLoading(this);
          this.$emit("confirmouChamado");
        },
        (err) => {
          Vue.CloseLoading(this);
          Vue.alertDanger(err, this);
        }
      );
    },

    excluirChamado(i) {
      // Pergunta se deseja realmente excluir

      //vm, title, content, callSim, callNao
      var vm = this;
      Vue.Pergunta(
        vm,
        "Excluir",
        "Deseja realmente excluir o chamado ?",

        function () {
          vm.service = new Chamado(vm.$resource);
          vm.service.delChamado(i.id, vm.getUser.id).then(
            function () {
              vm.$emit("confirmouChamado");
            },
            () => {}
          );
        },

        null
      );
    },

    TempoEspera() {
      return "";

      /* if (
        data1 == null ||
        hora1 == null ||
        data2 == null ||
        hora2 == null ||
        data1 == "" ||
        hora1 == "" ||
        data2 == "" ||
        hora2 == ""
      )
        return "";

      var data1_ajustada = Vue.getDataInput(data1);
      var day1 = new Date(data1_ajustada + "T" + hora1 + ":00");
      var data2_ajustada = Vue.getDataInput(data2);
      var day2 = new Date(data2_ajustada + "T" + hora2 + ":10");
      var difference = new Date(day2 - day1);

      var resultado = "";
      resultado += difference.getUTCHours() + " Horas e ";
      resultado += difference.getUTCMinutes() + " Minutos";

      return "Tempo para finalização: " + resultado; */
    },

    updateFinalizar() {
      var vm = this;
      var wsql =
        "UPDATE chamado SET resolvido = " +
        (vm.resolvido ? "True" : "False") +
        " WHERE id=" +
        vm.file.id;

      vm.service = new ExecutaSQL(vm.$resource);
      vm.service.get(wsql).then(
        function () {
          vm.$emit("confirmouChamado");
          vm.modal_retorno = false;
        },
        (err) => {
          console.log(err);
        }
      );

      /* Vue.Pergunta(
        vm,
        "Atendimento",
        "Deseja confirmar operação",
        function () {
          
        },
        function () {}
      ); */
    },

    copiaIDAnyDesk(texto) {
      if (texto == null || texto == "") {
        Vue.Mensagem(this, "ID AnyDesk", "ID AnyDesk não informado");
        return;
      }

      let text = texto;
      navigator.clipboard.writeText(text);
      Vue.Mensagem(this, "ID AnyDesk", "Copiado com sucesso!");
    },

    verificaBloqueiosVersoes() {
      this.service = new GenCli(this.$resource);
      this.service.getStatus(this.file.cnpj).then(
        function (ret) {
          this.dtVersoes = JSON.parse(ret.genCli);
          var wstatus = JSON.parse(ret.statusSigad);
          if (wstatus != null) {
            this.dtStatus = wstatus.split("|")[2];
          } else {
            this.dtStatus = "";
          }
        },
        () => {}
      );
    },
  },
};
</script>
<style>
</style>